module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "reglink",
    class: _vm.classes,
    style: (_vm.styles),
    attrs: {
      "target": "_blank",
      "href": _vm.link
    }
  }, [_c('span', [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c21bafea","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/regularLink/RegularLink.vue
// module id = be0336ea6f5c5b5116cb
// module chunks = 6